import { QuestionCircleOutlined } from '@ant-design/icons'
import { Form, Modal, Select } from 'antd'
import { string } from 'prop-types'
import { useCallback, useMemo, useRef, useState } from 'react'
import { PageHeader } from '~/components/PageHeader'
import CourseTable from '../CourseTable'
import {
  useAssignCourseUser,
  useDeleteCourseMutation,
  useDuplicateCourseMutation
} from '../mutation'
import { useGetDoctors, useUpcomingCoursesQuery } from '../query'

const { confirm } = Modal

const UpcomingCourses = ({ filterInput }) => {
  const { data: upcomingCourses, isLoading } = useUpcomingCoursesQuery()
  const { mutate: deleteCourse } = useDeleteCourseMutation()
  const { mutate: duplicateCourse } = useDuplicateCourseMutation()
  const [openAssignUserModel, setOpenAssignUserModel] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState()
  const { mutate: assignCourseUserMutate } = useAssignCourseUser()
  const assignUserForm = useRef()
  const handleAssignServer = useCallback((values) => {
    assignCourseUserMutate(
      {
        course_id: selectedCourse?.id,
        ...values
      },
      {
        onSuccess: () => {
          setOpenAssignUserModel(false)
        }
      }
    )
  }, [assignCourseUserMutate, selectedCourse?.id])

  const confirmDelete = (courseId, courseName) => {
    confirm({
      title: 'Confirm',
      icon: <QuestionCircleOutlined />,
      content: `Do you want to delete course ${courseName}?`,
      okText: 'YES',
      okType: 'danger',
      cancelText: 'NO',
      onOk: () => {
        deleteCourse(courseId)
      }
    })
  }

  const filterUpcomingCourses = useMemo(() => {
    const filter = filterInput.toLowerCase()
    if (!upcomingCourses) {
      return []
    }

    return upcomingCourses.filter((course) => course.name.toLowerCase().includes(filter))
  }, [upcomingCourses, filterInput])

  const { data } = useGetDoctors()

  return (
    <>
      <PageHeader className="radup-page-header" />
      <CourseTable
        data={filterUpcomingCourses}
        loading={isLoading}
        duplicateCourse={duplicateCourse}
        confirmDelete={confirmDelete}
        setOpenAssignUserModel={setOpenAssignUserModel}
        setSelectedCourse={setSelectedCourse}
      />

      <Modal
        title={'Assign a user'}
        open={openAssignUserModel}
        destroyOnHidden
        onOk={() => {
          assignUserForm.current.submit()
        }}
        onCancel={() => setOpenAssignUserModel(false)}
      >
        <Form ref={assignUserForm} preserve={false} onFinish={handleAssignServer}>
          <Form.Item label="User" name="user_id">
            <Select
              showSearch
              optionFilterProp='label'
              options={data?.map(item => ({
                value: item.id,
                label: item.name
              }))}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

UpcomingCourses.propTypes = {
  filterInput: string.isRequired
}

export default UpcomingCourses
